import * as React from "react";
import { Lightbox, LightboxType } from "../../../../react-core/Html/Components/Lightbox";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { ITableConfig, Table } from "../../../Shared/Table/Table";
import { CommentsAndDocumentsAction, ICommentsAndDocumentsQuery } from "./Action/CommentsAndDocumentsLoadAction";
import { CommentsAndDocumentsResultTable } from "./CommentsAndDocumentsResultTable";

interface IHistoricWorkflowResultTable {
    data: any;
    onPageChange: (currentPage, pageSize) => void;
    usingInTools?: (row) => void;
    errorMsg?: string;
}

export const HistoricWorkflowResultTable = (props: IHistoricWorkflowResultTable) => {
    if (!props.data) {return null;}

    const [currentPage, setCurrentPage] = React.useState(1);
    const [isShowLightBox, setIsShowLightBox] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [commentsAndDocumentsLoadQuery, setCommentsAndDocumentsLoadQuery] = React.useState({});

    const search = (query, currentPage, pageSize) => {
        CommentsAndDocumentsAction.loadCommentsAndDocuments(query, currentPage, pageSize, (res) => {
            setData(res);
        });
    };

    const onCommentsAndDocumentsLoad = (query: ICommentsAndDocumentsQuery) => {
        setCommentsAndDocumentsLoadQuery(query);
        search(query, 1, 10);
    };

    const onCommentsAndDocumentsPageChange = (currentPage, pageSize) => {
        search(commentsAndDocumentsLoadQuery, currentPage, pageSize);
    };

    const col: ITableConfig[] = [
        {
            title: "Policy number",
            key: "PolicyNumber",
        },
        {
            title: "Demand type",
            key: "DemandTypeString",
        },
        {
            title: "Case creation date",
            key: "CaseCreationDate",
            render: (data) => {
                return JsonDateParser.getFormatDateString(JsonDateParser.toDate(data), "dd-MM-yyyy");
            },
        },
        { title: "First name", key: "FirstName" },
        {
            title: "Surname",
            key: "Surname",
        },
        {
            title: "Status",
            key: "CancelledNotification",
        },
        {
            title: "Comments/Documents",
            key: "MoreDetails",
            render: (data) => {
                const caseDataId = data.split("|")[0];
                const demandType = data.split("|")[1];
                const caseGroupSequenceNumber = data.split("|")[2];
                const sequenceNumber = data.split("|")[3];

                return (
                    <div className="more-summary-tile">
                        <button
                            className="more-summary-tile-button label-sr-only"
                            onClick={() => {
                                setIsShowLightBox(true);
                                onCommentsAndDocumentsLoad({
                                    caseDataId: caseDataId,
                                    demandType: demandType,
                                    caseGroupSequenceNumber: caseGroupSequenceNumber,
                                    sequenceNumber: sequenceNumber,
                                });
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <hr />
            <Table
                data={props.data.PageOfResults}
                col={col}
                showEmptyMsg
                emptyMsg={props.errorMsg}
                cssWrapper="mb-60"
                needPagination={{
                    totalNumOfResult: props.data.TotalNumberOfResults,
                    onPaginationChange: (pageIndex, pageSize) => {
                        setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex, pageSize);
                    },
                    currentPage: currentPage,
                }}
            />
            {isShowLightBox && (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    show={isShowLightBox}
                    onClose={() => setIsShowLightBox(false)}
                    type={LightboxType.Modal}
                    title={"Comments & Documents"}
                >
                    <CommentsAndDocumentsResultTable
                        data={data}
                        onPageChange={(currentPage, pageSize) =>
                            onCommentsAndDocumentsPageChange(currentPage, pageSize)
                        }
                    />
                </Lightbox>
            )}
        </>
    );
};
